import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, buyerOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const TitleStatusReport = ({ data }) => {
  const [buyerId, setBuyerId] = useState(null);
  const [sellerId, setSellerId] = useState(null);
  const [titleStatus, setTitleStatus] = useState();


  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'title-status-report',
      params: { 'sellerId': sellerId, 'buyerId': buyerId, status: titleStatus }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Title Status Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Buyer:</Text>
      <SearchableSelect
        placeholder="Select Buyer"
        options={buyerOptions(data)}
        value={buyerId}
        onChange={setBuyerId}
      />
      <Text style={styles.label}>Title Status:</Text>
      <select style={styles.select} onChange={(e) => setTitleStatus(e.target.value)}>
        <option key="status-all">All</option>
        <option key="status-received">Received</option>
        <option key="status-transferred">Transferred</option>
        <option key="status-release">Release</option>
        <option key="status-problem">Problem</option>
        <option key="status-missing">Missing</option>
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default TitleStatusReport;
